import type { VnGoldPrice } from '@/hooks/useVnGoldPrices';
import type { VnGoldHistory } from '@/hooks/useVnGoldHistory';

export const mockVnGoldPrices: VnGoldPrice[] = [
  {
    id: 'mock-sjc-1l',
    type_code: 'SJL1L10',
    name: 'Vàng miếng SJC 1L',
    buy: 141300000,
    sell: 144300000,
    change_buy: 700000,
    change_sell: 700000,
    change_percent: 0.50,
    updated_at: '2026-08-18T14:30:00Z',
  },
  {
    id: 'mock-sjc-5l',
    type_code: 'SJL5L10',
    name: 'Vàng miếng SJC 5L',
    buy: 141300000,
    sell: 144300000,
    change_buy: 700000,
    change_sell: 700000,
    change_percent: 0.50,
    updated_at: '2026-08-18T14:30:00Z',
  },
  {
    id: 'mock-nhan-sjc',
    type_code: 'SJC999',
    name: 'Nhẫn tròn SJC 9999',
    buy: 140800000,
    sell: 143800000,
    change_buy: 650000,
    change_sell: 650000,
    change_percent: 0.46,
    updated_at: '2026-08-18T14:29:00Z',
  },
  {
    id: 'mock-nhan-pnj',
    type_code: 'PNJ999',
    name: 'Nhẫn tròn PNJ 9999',
    buy: 140600000,
    sell: 144200000,
    change_buy: 600000,
    change_sell: 600000,
    change_percent: 0.42,
    updated_at: '2026-08-18T14:29:00Z',
  },
  {
    id: 'mock-doji',
    type_code: 'DOJI999',
    name: 'Vàng DOJI 9999',
    buy: 141200000,
    sell: 144400000,
    change_buy: 720000,
    change_sell: 720000,
    change_percent: 0.51,
    updated_at: '2026-08-18T14:28:00Z',
  },
  {
    id: 'mock-24k',
    type_code: 'V24K',
    name: 'Vàng 24K (99.99%)',
    buy: 139900000,
    sell: 142900000,
    change_buy: 500000,
    change_sell: 500000,
    change_percent: 0.36,
    updated_at: '2026-08-18T14:28:00Z',
  },
  {
    id: 'mock-18k',
    type_code: 'V18K',
    name: 'Vàng 18K (75%)',
    buy: 105600000,
    sell: 108100000,
    change_buy: 400000,
    change_sell: 400000,
    change_percent: 0.38,
    updated_at: '2026-08-18T14:27:00Z',
  },
  {
    id: 'mock-14k',
    type_code: 'V14K',
    name: 'Vàng 14K (58.3%)',
    buy: 82100000,
    sell: 84600000,
    change_buy: 300000,
    change_sell: 300000,
    change_percent: 0.37,
    updated_at: '2026-08-18T14:27:00Z',
  },
  {
    id: 'mock-10k',
    type_code: 'V10K',
    name: 'Vàng 10K (41.7%)',
    buy: 58600000,
    sell: 60400000,
    change_buy: 200000,
    change_sell: 200000,
    change_percent: 0.34,
    updated_at: '2026-08-18T14:27:00Z',
  },
  {
    id: 'mock-xau',
    type_code: 'XAUUSD',
    name: 'Vàng thế giới XAU/USD',
    buy: 2495.30,
    sell: 2496.10,
    change_buy: 12.50,
    change_sell: 12.50,
    change_percent: 0.50,
    updated_at: '2026-08-18T14:30:00Z',
  },
  {
    id: 'mock-9999-sjc',
    type_code: 'SJC9999',
    name: 'Vàng SJC 9999',
    buy: 141000000,
    sell: 144000000,
    change_buy: 680000,
    change_sell: 680000,
    change_percent: 0.48,
    updated_at: '2026-08-18T14:28:00Z',
  },
  {
    id: 'mock-pnj',
    type_code: 'PNJ',
    name: 'Vàng PNJ',
    buy: 140500000,
    sell: 143900000,
    change_buy: 620000,
    change_sell: 620000,
    change_percent: 0.44,
    updated_at: '2026-08-18T14:28:00Z',
  },
];

function generateMockHistory(typeCode: string, name: string, basePrice: number): VnGoldHistory[] {
  const result: VnGoldHistory[] = [];
  let currentPrice = basePrice - 8000000;
  for (let i = 29; i >= 0; i--) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    const change = (Math.random() - 0.45) * 1200000;
    currentPrice += change;
    const buy = Math.round(currentPrice / 1000) * 1000;
    const sell = Math.round((currentPrice + 3000000) / 1000) * 1000;
    const changeBuy = Math.round(change);
    const pct = Number((changeBuy / buy * 100).toFixed(2));

    result.push({
      id: `mock-hist-${typeCode}-${i}`,
      type_code: typeCode,
      name,
      buy,
      sell,
      change_buy: changeBuy,
      change_sell: changeBuy,
      change_percent: pct,
      record_date: date.toISOString().split('T')[0],
      created_at: date.toISOString(),
    });
  }
  return result;
}

export const mockVnGoldHistory: Record<string, VnGoldHistory[]> = {
  SJL1L10: generateMockHistory('SJL1L10', 'Vàng miếng SJC 1L', 141300000),
  SJC999: generateMockHistory('SJC999', 'Nhẫn tròn SJC 9999', 140800000),
  PNJ999: generateMockHistory('PNJ999', 'Nhẫn tròn PNJ 9999', 140600000),
  DOJI999: generateMockHistory('DOJI999', 'Vàng DOJI 9999', 141200000),
  V24K: generateMockHistory('V24K', 'Vàng 24K', 139900000),
  V18K: generateMockHistory('V18K', 'Vàng 18K', 105600000),
  V14K: generateMockHistory('V14K', 'Vàng 14K', 82100000),
  XAUUSD: generateMockHistory('XAUUSD', 'Vàng thế giới XAU/USD', 2495),
};